import React, { useState, useEffect } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';

const testimonials = [
    {
        name: 'Ahmed Khan',
        position: 'Business Owner',
        content: "میری فیملی کے طلاق کے کیس میں انہوں نے بہت مدد کی۔ ان کی مہارت اور ہمدردی نے ہمیں مشکل وقت سے نکالا۔ میں اپنے تمام دوستوں کو ان کی خدمات کی سفارش کرتا ہوں۔",
        category: 'Family',
        rating: 5,
        lang: 'urdu',
    },
    {
        name: 'Saima Bibi',
        position: 'Housewife',
        content: "انہوں نے میری بچوں کی کسٹڈی کے لیے لڑائی لڑی اور ہر قدم پر میرا ساتھ دیا۔ مشکل وقت میں ان کا حوصلہ اور پیشہ ورانہ مہارت نے میری زندگی بدل دی۔ بہت شکرگزار ہوں۔",
        category: 'Family',
        rating: 5,
        lang: 'urdu',
    },
    {
        name: 'Zainab Fatima',
        position: 'Teacher',
        content: "طلاق کے بعد جائیداد کے تقسیم کے معاملے میں ان کی قانونی مہارت نے مجھے میرے حقوق دلوائے۔ انہوں نے میرا کیس انتہائی احترام اور صبر سے سنبھالا۔",
        category: 'Family',
        rating: 4,
        lang: 'urdu',
    },
    {
        name: 'Bilal Ahmed',
        position: 'Shopkeeper',
        content: "ایک جھوٹے الزام سے بچنے کے لیے انہوں نے میرا کیس لڑا اور میری بے گناہی ثابت کی۔ وہ میرے ساتھ ہر وقت کھڑے رہے اور عدالت میں میری آواز بنے۔ ان پر بھروسہ کیا جا سکتا ہے۔",
        category: 'Criminal',
        rating: 5,
        lang: 'urdu',
    },
    {
        name: 'Usman Malik',
        position: 'Software Engineer',
        content: "میرے خلاف غلط الزامات لگائے گئے تھے، لیکن ان کی وجہ سے میں اپنی بے گناہی ثابت کر سکا۔ ان کی پیشہ ورانہ مہارت اور قانونی سمجھ بے مثال ہے۔",
        category: 'Criminal',
        rating: 5,
        lang: 'urdu',
    },
    {
        name: 'Fahad Mahmood',
        position: 'Bank Manager',
        content: "میری پراپرٹی کے تنازعے میں انہوں نے بہترین قانونی حکمت عملی اپنائی۔ ان کی سخت محنت اور وقف کی وجہ سے ہم فیصلے میں کامیاب ہوئے۔",
        category: 'Civil',
        rating: 5,
        lang: 'urdu',
    },
    {
        name: 'Ayesha Tariq',
        position: 'Entrepreneur',
        content: "میرے نئے سٹارٹ اپ کے لیے ان کا قانونی مشورہ بالکل درست تھا۔ انہوں نے معاہدوں کی تیاری میں میری مدد کی اور میرے کاروبار کو محفوظ بنایا۔ بہت پیشہ ورانہ اور قابل اعتماد۔",
        category: 'Legal',
        rating: 5,
        lang: 'urdu',
    },
    {
        name: 'Farhan Ali',
        position: 'Transporter',
        content: "میرے ٹرانسپورٹ بزنس کے لائسنس کے مسائل میں ان کی قانونی رہنمائی نے مجھے بہت فائدہ پہنچایا۔ وہ ہمیشہ دستیاب تھے اور میرے سوالوں کا فوری جواب دیتے تھے۔",
        category: 'Legal',
        rating: 4,
        lang: 'urdu',
    },
];

const categories = ['All', 'Family', 'Criminal', 'Civil', 'Legal'];

const TestimonialsSection = () => {
    const [activeCategory, setActiveCategory] = useState('All');
    const [filteredTestimonials, setFilteredTestimonials] = useState(testimonials);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        if (activeCategory === 'All') {
            setFilteredTestimonials(testimonials);
        } else {
            setFilteredTestimonials(
                testimonials.filter((testimonial) => testimonial.category === activeCategory)
            );
        }
        setCurrentIndex(0);
    }, [activeCategory]);

    const nextSlide = () => {
        if (isAnimating || filteredTestimonials.length <= 1) return;
        
        setIsAnimating(true);
        setCurrentIndex((prev) => (prev + 1) % filteredTestimonials.length);
        
        setTimeout(() => {
            setIsAnimating(false);
        }, 500);
    };

    const prevSlide = () => {
        if (isAnimating || filteredTestimonials.length <= 1) return;
        
        setIsAnimating(true);
        setCurrentIndex((prev) => (prev - 1 + filteredTestimonials.length) % filteredTestimonials.length);
        
        setTimeout(() => {
            setIsAnimating(false);
        }, 500);
    };

    const goToSlide = (index) => {
        if (isAnimating) return;
        setIsAnimating(true);
        setCurrentIndex(index);
        
        setTimeout(() => {
            setIsAnimating(false);
        }, 500);
    };

    return (
        <section className="py-20 bg-gradient-to-b from-gray-50 to-gray-100">
            <div className="container mx-auto px-4 max-w-6xl">
                <div className="text-center mb-12">
                    <h2 className="text-4xl font-bold mb-4 text-gray-800">Client Testimonials</h2>
                    <p className="text-gray-600 max-w-2xl mx-auto">
                        See what our clients say about our legal services and commitment to excellence.
                    </p>
                </div>

                {/* Category Tabs */}
                <div className="flex justify-center mb-12 flex-wrap">
                    {categories.map((category) => (
                        <button
                            key={category}
                            onClick={() => setActiveCategory(category)}
                            className={`px-5 py-2 mx-2 mb-2 rounded-full transition-all ${
                                activeCategory === category
                                    ? 'bg-indigo-600 text-white font-medium shadow-md'
                                    : 'bg-white text-gray-600 hover:bg-gray-100'
                            }`}
                        >
                            {category === 'Family' ? 'Family Law' : 
                             category === 'Criminal' ? 'Criminal Law' : 
                             category === 'Civil' ? 'Civil Law' : 
                             category === 'Legal' ? 'Legal Advice' : 'All'}
                        </button>
                    ))}
                </div>

                {filteredTestimonials.length > 0 ? (
                    <>
                        <div className="relative">
                            {/* Slider Content */}
                            <div className="flex justify-center">
                                <div 
                                    className={`bg-white p-10 rounded-xl shadow-lg max-w-3xl w-full transform transition-all duration-500 ${
                                        isAnimating ? 'scale-95 opacity-70' : 'scale-100 opacity-100'
                                    }`}
                                >
                                    <div className="flex justify-between items-start mb-6">
                                        <div className="flex">
                                            {[...Array(filteredTestimonials[currentIndex].rating)].map((_, i) => (
                                                <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                                            ))}
                                            {[...Array(5 - filteredTestimonials[currentIndex].rating)].map((_, i) => (
                                                <Star key={i + filteredTestimonials[currentIndex].rating} className="w-5 h-5 text-gray-300" />
                                            ))}
                                        </div>
                                        <span className="text-sm text-gray-400 italic px-3 py-1 bg-gray-100 rounded-full">
                                            {filteredTestimonials[currentIndex].category === 'Family' ? 'Family Law' : 
                                             filteredTestimonials[currentIndex].category === 'Criminal' ? 'Criminal Law' : 
                                             filteredTestimonials[currentIndex].category === 'Civil' ? 'Civil Law' : 'Legal Advice'}
                                        </span>
                                    </div>
                                    <div className="mb-8">
                                        <p className={`text-gray-700 text-lg mb-8 leading-relaxed min-h-32 ${
                                            filteredTestimonials[currentIndex].lang === 'urdu' ? 'font-sans text-right' : ''
                                        }`}>
                                            <span className="text-indigo-600 text-2xl">"</span>
                                            {filteredTestimonials[currentIndex].content}
                                            <span className="text-indigo-600 text-2xl">"</span>
                                        </p>
                                    </div>
                                    <div className="flex justify-between items-center border-t pt-4 border-gray-100">
                                        <div>
                                            <h4 className="font-bold text-gray-900 text-lg">
                                                {filteredTestimonials[currentIndex].name}
                                            </h4>
                                            <p className="text-gray-500 text-sm">
                                                {filteredTestimonials[currentIndex].position}
                                            </p>
                                        </div>
                                        <div className="flex space-x-1">
                                            <button
                                                onClick={prevSlide}
                                                disabled={isAnimating}
                                                className="bg-gray-100 hover:bg-gray-200 text-gray-600 p-2 rounded-full transition-colors disabled:opacity-50"
                                            >
                                                <ChevronLeft className="w-5 h-5" />
                                            </button>
                                            <button
                                                onClick={nextSlide}
                                                disabled={isAnimating}
                                                className="bg-gray-100 hover:bg-gray-200 text-gray-600 p-2 rounded-full transition-colors disabled:opacity-50"
                                            >
                                                <ChevronRight className="w-5 h-5" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Dots for navigation */}
                        {filteredTestimonials.length > 1 && (
                            <div className="flex justify-center mt-6 space-x-2">
                                {filteredTestimonials.map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => goToSlide(index)}
                                        className={`w-3 h-3 rounded-full transition-colors ${
                                            currentIndex === index ? 'bg-indigo-600' : 'bg-gray-300 hover:bg-gray-400'
                                        }`}
                                        aria-label={`Go to testimonial ${index + 1}`}
                                    />
                                ))}
                            </div>
                        )}
                    </>
                ) : (
                    <div className="text-center py-10">
                        <p className="text-gray-500">No testimonials found in this category.</p>
                    </div>
                )}
            </div>
        </section>
    );
};

export default TestimonialsSection;